export default "__VITE_ASSET__C$JAtCmR__"